import React from 'react';
import { observer } from 'mobx-react-lite';
import AssignBoxV2 from '../../dropdowns/assignPopup';
import { useCreateModalAssignActions } from '../../dropdowns/assignPopup/assignActions';
import TaskStatusDropdownV2 from '../../dropdowns/taskStatusDropdown';
import PriorityDropdownV2 from '../../dropdowns/priorityDropdown';
import LabelDropdownV2 from '../../dropdowns/labelDropdown';
import EstimateDropdownV2 from '../../dropdowns/estimateDropdown';
import GroupDropdown from '../../dropdowns/statusDropdown';
import CalendarPopUpV2 from '../../calendarPopUp';
import { StatusListInterface } from '../../../interfaces/ProjectInterface';
import { TaskModel } from '../../../mobx/models/task';
import { ProjectModel } from '../../../mobx/models/project';
import { Icons } from './styles';

type Props = {
  project: ProjectModel;
  isTemplateProject: boolean;
  isRecurringTask: boolean;
  labelsVersion: number;
  priorityVersion: number;
  currentStatusId?: string;
  groupId?: string;
  setIsAssignDropdownOpen: (open: boolean) => void;
  onUpdateStatus: (status: StatusListInterface, previousStatus: StatusListInterface) => void;
  loadData?: () => void;
  data?: TaskModel;
};

const TaskFormFields = ({
  project,
  isTemplateProject,
  isRecurringTask,
  labelsVersion,
  priorityVersion,
  currentStatusId,
  groupId,
  setIsAssignDropdownOpen,
  onUpdateStatus,
  loadData,
  data
}: Props) => {
  const assignActions = useCreateModalAssignActions();
  return (
    <Icons>
      {project?.statusEnable && project?.statusData?.length > 0 && (
        <TaskStatusDropdownV2
          defaultStatus={project?.defaultStatus}
          statusList={project?.statusData || []}
          currentStatusId={currentStatusId}
          isCreateTask={true}
          onUpdateStatus={onUpdateStatus}
        />
      )}
      <AssignBoxV2
        setIsDropdownOpen={setIsAssignDropdownOpen}
        projectUsers={project?.users || []}
        context={{ mode: 'createModal' }}
        onAssign={assignActions.onAssign}
        onUnassign={assignActions.onUnassign}
        isMultiAssignee={project?.multiAssignee}
      />
      {!isTemplateProject && (
        <CalendarPopUpV2 isCreateTask={true} loadData={loadData} isRecurringTask={isRecurringTask} data={data} />
      )}
      {project?.isGroupEnabled && project.taskGroups && project.taskGroups?.length > 0 && (
        <GroupDropdown isCreateTaskModal currentProject={project} value={groupId} />
      )}
      {project?.isEstimate && <EstimateDropdownV2 isCreateTask={true} />}
      {project?.priority?.enabled && (
        <PriorityDropdownV2 key={`priority-dropdown-${priorityVersion}`} currentProject={project} isCreateTask={true} />
      )}
      {project?.labelsEnabled && (
        <LabelDropdownV2 key={`label-dropdown-${labelsVersion}`} currentProject={project} isCreateTask={true} />
      )}
    </Icons>
  );
};

export default observer(TaskFormFields);
